var _g, _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFilteredData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 120,
    viewBox: "0 0 168 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8404_3429)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.585,
    cy: 87.2485,
    rx: 5.83059,
    ry: 48.5234,
    transform: "rotate(67.3796 116.585 87.2485)",
    fill: "url(#paint0_linear_8404_3429)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 39.9336,
    width: 57.8136,
    height: 70.3923,
    rx: 1.45139,
    transform: "rotate(-25.5486 13 39.9336)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeDasharray: "8.72 8.72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0405,
    y: 34.373,
    width: 57.8136,
    height: 70.3923,
    rx: 1.45139,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeDasharray: "8.72 8.72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2025 79.9599C77.2024 80.1768 77.2627 80.3895 77.3768 80.574C77.4908 80.7585 77.654 80.9077 77.848 81.0046L80.1827 82.172C80.3607 82.2609 80.5585 82.3029 80.7573 82.2939C80.9561 82.2849 81.1493 82.2252 81.3185 82.1205C81.4878 82.0158 81.6274 81.8696 81.7243 81.6958C81.8211 81.5219 81.8719 81.3262 81.8718 81.1272V72.9559C81.8721 72.3773 82.0871 71.8195 82.4753 71.3905L90.907 62.0647C91.0581 61.8972 91.1574 61.6896 91.1931 61.4669C91.2287 61.2441 91.199 61.0159 91.1076 60.8097C91.0162 60.6034 90.8671 60.4281 90.6782 60.3049C90.4893 60.1816 90.2687 60.1158 90.0431 60.1152H69.0312C68.8054 60.1153 68.5845 60.1809 68.3953 60.3039C68.206 60.427 68.0565 60.6023 67.9648 60.8086C67.8732 61.0149 67.8433 61.2434 67.8788 61.4663C67.9143 61.6892 68.0138 61.8971 68.165 62.0647L76.599 71.3905C76.9872 71.8195 77.2022 72.3773 77.2025 72.9559V79.9599Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8404_3429",
    x: 65.8532,
    y: 61.9357,
    width: 101.463,
    height: 50.6257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.94182,
    result: "effect1_foregroundBlur_8404_3429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8404_3429",
    x1: 110.761,
    y1: 38.7251,
    x2: 75.2106,
    y2: 61.2367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFilteredData);
export default __webpack_public_path__ + "static/media/no-filtered-data.bb021cece6c4ef12f8e986103503e40f.svg";
export { ForwardRef as ReactComponent };